import { render } from "./AuthorsTable.vue?vue&type=template&id=ca0fe8a4&scoped=true"
import script from "./AuthorsTable.vue?vue&type=script&lang=js"
export * from "./AuthorsTable.vue?vue&type=script&lang=js"

import "./AuthorsTable.vue?vue&type=style&index=0&id=ca0fe8a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0fe8a4"]])

export default __exports__